import About from "../components/About";
import Certifications from "../components/Certifications";
import Contact from "../components/Contact";
import Education from "../components/Education";
import Experience from "../components/Experience";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Projects from "../components/Projects";
import Skills from "../components/Skills";

const Home: React.FC = () => {
  return (
    <div
      className="min-h-screen bg-black 
        bg-[radial-gradient(circle_at_top_left,rgba(0,200,255,0.25),transparent),
        radial-gradient(circle_at_bottom_right,rgba(0,255,200,0.25),transparent)]
        text-white"
    >
      <Header />
      <main className="max-w-5xl mx-auto px-6 pb-24 pt-28">
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Education />
        <Projects />
        <Certifications />
        <Contact />
      </main>

      <Footer />
    </div>
  );
};

export default Home;
